/**
 * Roughly 1/2 page of text
 *
 * NOTE: updates to this must be accompanied by a database migration
 */
export const contactUsMessageMaximumChars = 1500;

export const contactUsMessageMinimumChars = 2;
